module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/campaigns/campaigns-edit/campaigns-edit.component.css
// module id = ./src/app/components/campaigns/campaigns-edit/campaigns-edit.component.css
// module chunks = main